// @flow

const generateData = (business: any, client: any) => ({
  welcomeParagraphs: [
    `Welcome to the secure payment portal for ${business.attributes.name}.`,
    `Here you'll be able to set up easy, one-click payments for ${
      client ? `${client.attributes.firstName}'s` : 'your'
    } tutoring sessions.`,
    'All your information is kept private and secure using Stripe.',
  ],
});

export default generateData;



// WEBPACK FOOTER //
// ./src/constants/payer/splash.js